import { request } from './http-client'

export interface IReferralActionData {
  action_type: 'enter' | 'register' | 'add_to_cart' | 'ordered'
  customer_id: string
  device_id: string
  fcm_token: string
  order_id: string
  platform_id: string
  referal_url_id: string | null
  source_id: string
  tg_chat_id?: string
}

const referalService = {
  get: (params: { referal_url: string }) =>
    request.get('/v2/referal-url', { params }),
  getUnique: (id: string) => request.get(`/v2/referal-urls-is-unique/${id}`),
  action: (data: IReferralActionData) =>
    request.post(`/v2/referal-url-actions`, data),
}

export default referalService
